// src/components/PostTradePage.js
import React from "react";
import AddTrade from "./AddTrade";

const PostTradePage = () => {
  return (
    <div className="post-trade-page">
      <AddTrade />
    </div>
  );
};

export default PostTradePage;
